import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../styles.module.scss'
import { useTranslation } from 'react-i18next'
import CardSubTitle from 'srcReact/Dashboard/components/common/CardSubTitle'
import Counts from 'srcReact/Dashboard/components/common/Counts'
import EngagementActivityGraph from '../EngagementActivityGraph'
import EngagementItem from './EngagementItem'
import { isMobileScreen } from 'srcReact/helpers/utils'

function EngagementActivity({ type, engagementActivityData, duration }) {
  const { t } = useTranslation()
  const [engagementData, setEngagementData] = useState(null)
  const [graphData, setGraphData] = useState(null)

  useEffect(() => {
    if (engagementActivityData && engagementActivityData[duration]) {
      const durationData = engagementActivityData[duration]
      if (durationData) {
        setEngagementData(durationData)
      }
      if (duration === '4W') {
        setGraphData(engagementActivityData['7D'])
      } else if (duration === '88D') {
        setGraphData(engagementActivityData['22D'])
      } else {
        setGraphData(engagementActivityData['91D'])
      }
    }
  }, [engagementActivityData, duration])

  return (
    <div className={parentStyles.activityData}>
      <div className={parentStyles.left}>
        <div className={parentStyles.list}>
          {type === 'workplace' && (
            <React.Fragment>
              <EngagementItem
                name={t('dashboard.activity.newEngagements.newGroupMembership')}
                icon='groups24'
                number={engagementData?.new_group_membership_count?.value}
                variant={engagementData?.new_group_membership_variation?.value}
              />
              <EngagementItem
                name={t('dashboard.activity.newEngagements.mixrParticipations')}
                icon='calendar24'
                number={engagementData?.mixr_participations_count?.value}
                variant={engagementData?.mixr_participations_variation?.value}
              />
            </React.Fragment>
          )}
          {type === 'group' && (
            <EngagementItem
              name={t('dashboard.activity.newEngagements.plannedSuggestedMixrs')}
              icon='calendar24'
              number={engagementData?.new_suggested_mixr_count?.value}
              variant={engagementData?.new_suggested_mixr_variation?.value}
            />
          )}

          <EngagementItem
            name={t('dashboard.activity.newEngagements.mediaShared')}
            icon='picture'
            number={engagementData?.new_picture_count.value}
            variant={engagementData?.new_picture_variation.value}
          />

          <EngagementItem
            name={t('dashboard.activity.newEngagements.comments')}
            icon='discussion'
            number={engagementData?.comment_count.value}
            variant={engagementData?.comment_variation.value}
          />

          <EngagementItem
            name={t('dashboard.activity.newEngagements.replies')}
            icon='chat24'
            number={engagementData?.reply_comment_count.value}
            variant={engagementData?.reply_comment_variation.value}
          />

          <EngagementItem
            name={t('dashboard.activity.newEngagements.reactions')}
            icon='heart'
            number={engagementData?.reaction_count.value}
            variant={engagementData?.reaction_variation.value}
          />
        </div>
      </div>
      {!isMobileScreen() && (
        <div className={parentStyles.right}>
          <Counts
            countTitle={t('dashboard.activity.newEngagements.engagementCount', {
              count: parseInt(engagementData?.new_engagement_count?.value)
            })}
            totalCountTitle={t('dashboard.activity.newEngagements.engagedCount', {
              count: engagementData?.engagement_rate_count?.value
            })}
            count={engagementData?.new_engagement_variation?.value}
            totalCount={engagementData?.engagement_rate_variation?.value}
          />
          <EngagementActivityGraph
            countGraphData={graphData?.engagement_count_graph}
            rateGraphData={graphData?.engagement_rate_graph}
          />
        </div>
      )}
    </div>
  )
}

export default EngagementActivity
